import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FiClock, FiArrowUp, FiArrowDown, FiChevronDown } from 'react-icons/fi';

const SortDropdown = ({ sortBy, setSortBy }) => {
  const sortOptions = [
    { id: 'newest', label: 'Newest First', icon: <FiClock className="w-4 h-4" /> },
    { id: 'price-low-high', label: 'Price: Low to High', icon: <FiArrowUp className="w-4 h-4" /> },
    { id: 'price-high-low', label: 'Price: High to Low', icon: <FiArrowDown className="w-4 h-4" /> }
  ];

  const activeSortOption = sortOptions.find(option => option.id === sortBy);

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-200 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black transition-all">
        <span className="text-sm font-medium text-gray-700">Sort by:</span>
        <span className="text-sm font-semibold text-gray-900">{activeSortOption.label}</span>
        <FiChevronDown className="w-4 h-4 text-gray-500" />
      </Menu.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-xl shadow-lg focus:outline-none z-50">
          <div className="py-2">
            {sortOptions.map((option) => (
              <Menu.Item key={option.id}>
                {({ active }) => (
                  <button
                    onClick={() => setSortBy(option.id)}
                    className={`${
                      active ? 'bg-gray-50' : ''
                    } group flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50`}
                  >
                    {option.icon}
                    <span className="ml-3">{option.label}</span>
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default SortDropdown;

